<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useCreditStore} from "@/stores/credit.store";
import Icon from "@/core/components/icon/Icon.vue";
import {useRouter} from "vue-router";

const {credit} = storeToRefs(useCreditStore());
const router = useRouter();

</script>

<template>
  <div
    v-if="credit?.balance !== undefined"
    class="flex flex-row bg-gray-100 items-center gap-1 pr-2 h-full max-h-8 rounded-full cursor-pointer"
    @click="router.push({name: 'patient-administration.communication'})"
  >
    <div class="border-[1px] border-primary rounded-full p-1 flex items-center justify-center">
      <Icon name="mdi-send" color="primary" :size="16" />
    </div>
    <span class="text-primary text-sm leading-tight"><span class="font-bold">{{ credit.balance }}</span> sms</span>
  </div>
</template>

<style scoped>

</style>
